import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var updateAdvancedPopServer = mutatorAction('updateAdvancedPopServer', function (popServer) {
    var store = connectedAccountsStore();
    store.connectAdvancedState.popServer = popServer;
});
//# sourceMappingURL=updateAdvancedPopServer.js.map